





















































































import { Component, Vue, Prop, Emit, Inject, Ref } from 'vue-property-decorator';
import SElementValidationErrors from './SElementValidationErrors.vue';
import SForm from './SForm.vue';

@Component({
  components: {
    SElementValidationErrors,
  },
})
export default class SInputBase extends Vue {
  @Prop({ required: true }) private value!: string;

  @Prop({ type: Boolean, required: true }) private isValid!: boolean;
  @Prop({ type: Boolean, required: true }) private hasWarning!: boolean;
  @Prop({ required: true }) private errorMessages!: string[] | null;

  @Inject({ from: 'sForm', default: undefined }) private sForm?: SForm;

  @Prop(Boolean) private disabled?: boolean;

  @Prop(String) private prefix?: string;
  @Prop(String) private suffix?: string;
  @Prop(String) private label?: string;
  @Prop({ type: Boolean, default: false }) private disableLabel!: boolean;
  @Prop({ type: Boolean, default: false }) private disableIcons!: boolean;

  @Prop({ type: Boolean, default: true }) private fullSize!: boolean;
  @Prop({ type: Boolean, default: true }) private bordered!: boolean;
  @Prop(Boolean) private pulse!: boolean;
  @Prop(Boolean) private inline?: boolean;
  @Prop(Boolean) private alignRight?: boolean;
  @Prop({
    type: String,
    required: false,
    default: 'text',
    validator: (value: string) => [ 'text', 'password', 'hidden' ].includes(value),
  }) private type!: string;

  @Prop(Boolean) private selectAllOnFocus!: boolean;

  @Ref() private readonly popoverRef!: Vue;
  @Ref() public readonly inputRef!: HTMLInputElement;
  @Ref() public readonly inputHolderRef!: HTMLElement;

  private focused = false;

  private get showLabel(): boolean {
    if (this.disableLabel) return false;

    return (
      this.sForm?.withLabels
    ) ? this.sForm!.withLabels || !!this.label : !!this.label;
  }

  private get labelText(): string {
    return this.label || this.$attrs.placeholder;
  }

  private get suffixIcon() {
    return this.suffix ? this.suffix : 'exclamation-circle';
  }

  private get prefixIcon() {
    return this.prefix ? this.prefix : 'exclamation-circle';
  }

  private get showSuffix() {
    if (this.disableIcons) return false;

    return (
      this.suffix || this.$scopedSlots.suffix ||
      (
        !this.$scopedSlots.prefix && !this.prefix &&
        !this.alignRight &&
        (!this.isValid || this.hasWarning)
      )
    );
  }

  private get showPrefix() {
    if (this.disableIcons) return false;

    return (
      this.prefix || this.$scopedSlots.prefix ||
      (
        !this.$scopedSlots.suffix && !this.suffix &&
        this.alignRight &&
        (!this.isValid || this.hasWarning)
      )
    );
  }

  private get listeners() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { input, ...listeners } = this.$listeners;
    return listeners;
  }

  public focus() {
    this.inputRef.focus();
  }

  private onFocus() {
    this.focused = true;
    if(this.selectAllOnFocus) {
      this.inputRef.select();
    }
  }

  public select() {
    this.inputRef.select();
  }

  public blur() {
    this.inputRef.blur();
  }

  public selectAllButFirst() {
    this.$nextTick(() => { // allows prepending minus on first focus
      this.inputRef.select(); // fix for firefox, allows setSelectionRange to work
      this.inputRef.setSelectionRange(1, this.inputRef.value.length, 'backward');
    });
  }

  @Emit('input')
  private handleInput(event: {target: HTMLInputElement}) {
    return event.target.value;
  }
}
